import DropdownNew from '../../common/dropdownNew';
import styles from './nfoStates.scss';
export const LiveBtn = ({ className, style }) => {
  return (
    <span
      className={`lil-px-4 lil-py-1 lil-rounded-md lil-font-semibold lil-text-white ${styles['btn-red']} ${className}`}
      style={style}
    >
      LIVE
    </span>
  );
};
export const UpcomingBtn = ({ className, style }) => {
  return (
    <span
      className={`lil-px-4 lil-py-1 lil-rounded-md lil-font-semibold lil-text-white ${styles['btn-blue']} ${className}`}
      style={style}
    >
      UPCOMING
    </span>
  );
};

export const ClosedBtn = ({ className, style }) => {
  return (
    <span
      className={`lil-px-4 lil-py-1 lil-rounded-md lil-font-semibold lil-text-white ${styles['btn-yellow']} ${className}`}
      style={style}
    >
      CLOSED
    </span>
  );
};
const content = (
  <div className="lil-flex lil-pt-6 lil-flex-wrap lil-items-start sm:lil-flex-col">
    <div className="lil-w-1/3 lil-pr-6 sm:lil-pr-0 sm:lil-w-full ">
      <div>
        <LiveBtn />
      </div>
      <p className="lil-pt-6 lil-text-base">
        These are the funds that are currently accepting payments/orders for
        future dates. Don’t miss the opportunity, invest now and get great
        returns.
      </p>
    </div>

    <div className="lil-w-1/3 lil-px-3 sm:lil-px-0 sm:lil-pt-12 sm:lil-w-full ">
      <div>
        <UpcomingBtn />
      </div>
      <p className="lil-pt-6 lil-text-base">
        These are the NFOs that are not yet launched. You cannot invest in them
        right now. You can start investing after the launch date and maximise
        your returns.
      </p>
    </div>

    <div className="lil-w-1/3 lil-pl-6 sm:lil-pl-0 sm:lil-pt-12 sm:lil-w-full ">
      <div>
        <ClosedBtn />
      </div>
      <p className="lil-pt-6 lil-text-base">
        These are the NFOs that are no longer accepting payments. Once the
        allotment is done, they’ll behave like normal mutual funds and accept
        payments.
      </p>
    </div>
  </div>
);

const header = 'What is a new fund offer or NFO?';

export const NFOStates = () => (
  <div>
    <div className="sm:lil-hidden">
      <h6 className="lil-mt-12">{header}</h6>
      {content}
    </div>
    <div className="lg:lil-hidden md:lil-hidden xl:lil-hidden">
      <DropdownNew heading={header} content={content} />
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./components/nfoPage/nfoStates/nfoStates.tsx